export default __webpack_public_path__ + "static/media/me2.8fc2c3fd.jpg";